export default async function ({ query, store, redirect }) {
  const unidade = store.getters['unidade/unidadeInformation'].cpfcnpj

  const { idTransacao } = query

  try {
    await store.dispatch('payment-safe2pay/statusPayment', {
      idTransacao,
      vendedor: unidade,
    })
    const result = store.getters['payment-safe2pay/allStatusPayment']

    if (result && result.status === 'Autorizado') {
      //
    } else {
      redirect('/')
    }
  } catch (error) {
    redirect('/')
    console.error(error)
  }
}
